import {useQuery, UseQueryResult} from "@tanstack/react-query";
import {CustomAxiosError, useApiCalls} from "../../../../../../logics/api_config";
import {useAuth} from "../../../../../../utils/contexts/auth-context";
import {IDescription} from "../../../../../../utils/interfaces/service/description/IDescription";


const useApiGetDescription = (pk: number | undefined): UseQueryResult<IDescription, CustomAxiosError> => {
    const {selectedCompany} = useAuth();

    const {get} = useApiCalls()

    async function doGet(pk: number | undefined): Promise<IDescription> {
        try {
            const response = await get(`/api/company/${selectedCompany?.company_token}/service/description/${pk}`);
            return response?.data;
        } catch (error) {
            throw error;
        }
    }

    return useQuery({
        queryKey: ["useApiGetDescription", pk],
        queryFn: () => doGet(pk),
        enabled: !!pk,
    })

};

export default useApiGetDescription